import { type AudioMode } from "@/lib/ws";
import { Button } from "@/components/ui/button";

const MODES: { value: AudioMode; label: string }[] = [
  { value: "file", label: "文件模式" },
  { value: "stream", label: "流式模式" },
];

interface AudioModeToggleProps {
  value: AudioMode;
  onChange: (mode: AudioMode) => void;
  disabled?: boolean;
}

export function AudioModeToggle({ value, onChange, disabled }: AudioModeToggleProps) {
  return (
    <div
      className="flex items-center gap-1 rounded-md border p-0.5"
      style={disabled ? { opacity: 0.5, pointerEvents: "none" } : undefined}
    >
      {MODES.map((m) => (
        <Button
          key={m.value}
          size="sm"
          variant={value === m.value ? "default" : "ghost"}
          className="h-7 px-3 text-xs"
          onClick={() => onChange(m.value)}
          disabled={disabled}
        >
          {m.label}
        </Button>
      ))}
    </div>
  );
}
